import { render, staticRenderFns } from "./yearly_area_compare.vue?vue&type=template&id=004dde50&scoped=true"
import script from "./yearly_area_compare.vue?vue&type=script&lang=js"
export * from "./yearly_area_compare.vue?vue&type=script&lang=js"
import style0 from "./yearly_area_compare.vue?vue&type=style&index=0&id=004dde50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004dde50",
  null
  
)

export default component.exports